<agx-pivot-table
  [columnMappings]="columnMappings"
  [(selectedColumns)]="selectedColumns"
  [aggregatedColumns]="aggregatedColumns"
  [data]="cartonGroupings"
  [isLoading]="isLoading"
  [scrollHeight]="scrollHeight()"
/>
